import {
    FormSessionPrefillRequestDto,
    FormSessionPrefillRequestStateType
} from "../../../client/formsession/FormSessionApiClient";

export enum PrefillStatus {
    ALL_OBTAINED = 1,
    IN_PROGRESS = 2,
    FAILED = 3,
}

const isObtained = (r: FormSessionPrefillRequestDto) =>
    r.state === FormSessionPrefillRequestStateType.OBTAINED;

const isPrefillInProgress = (r: FormSessionPrefillRequestDto) =>
    r.state === FormSessionPrefillRequestStateType.IN_PROGRESS;

const isPrefillFailed = (r: FormSessionPrefillRequestDto) =>
    r.state === FormSessionPrefillRequestStateType.FAILED;

const allObtained = (reqs: FormSessionPrefillRequestDto[]) =>
    reqs.length === 0 || reqs.every(isObtained);

export const isAnyInProgress = (reqs: FormSessionPrefillRequestDto[]) =>
    reqs.length > 0 && reqs.some(isPrefillInProgress);

export const isAnyFailed = (reqs: FormSessionPrefillRequestDto[]) =>
    reqs.length > 0 && reqs.some(isPrefillFailed);

export function getRequiredPrefillStatus(requests: FormSessionPrefillRequestDto[]): PrefillStatus {
    if (allObtained(requests)) {
        return PrefillStatus.ALL_OBTAINED;
    }

    if (isAnyFailed(requests)) {
        return PrefillStatus.FAILED;
    }

    return PrefillStatus.IN_PROGRESS;
}

export function getOptionalPrefillStatus(requests: FormSessionPrefillRequestDto[]): PrefillStatus {
    if (allObtained(requests)) {
        return PrefillStatus.ALL_OBTAINED;
    }

    if (isAnyInProgress(requests)) {
        return PrefillStatus.IN_PROGRESS;
    }

    return PrefillStatus.FAILED;
}

export function getRequiredPrefillRequests(prefillRequests: FormSessionPrefillRequestDto[]): FormSessionPrefillRequestDto[] {
    return prefillRequests.filter(request => request.required === true);
}

export function getOptionalPrefillRequests(prefillRequests: FormSessionPrefillRequestDto[]): FormSessionPrefillRequestDto[] {
    return prefillRequests.filter(request => request.required === false);
}
